import { render } from "./Main.vue?vue&type=template&id=6e5d0dab"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/security/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__